import http from '@/api/http';
import { serialize } from '@/utils/tools';

export async function listProject(token, data) {

    // console.log(data);
    let query = "";
    let qq = "?"
    if (data.pic_h > 0) {
        query += "?pic_h=" + data.pic_h
        qq = "&"
    }
    if (data.pic_w > 0) {
        query += qq +"pic_w=" + data.pic_w
        qq = "&"
    }
    if (data.company_id > 0) {
        query += qq + "company_id=" + data.company_id
    }

    // console.log(query);

    try {

        // console.log(query);

        const response = await http.get('api/v1/project/list' + query,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function listUsers(token, id) {
    try {
        const response = await http.get('api/v1/user/project?id=' + id,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }    
}

export async function listRoles(token, projectId) {
    try {
        const dataParam = { project_id: projectId }

        const response = await http.post(
            'api/v1/role/list', 
            dataParam,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return false
    }
}


export async function getProject(token, id, width) {
    try {
        const response = await http.get('api/v1/project?id=' + id,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function inviteCode(token, data) {
    try {
        let dataPram = {
            'id': data.id,
            'role': data.role,
        }

        const response = await http.get('api/v1/project/link-code?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return error.response.data
    }
}

export async function updateProject(token, data) {
    try {
        let dataPram = {
            'name': data.name,
            'description': data.description,
            'budget': data.budget ? data.budget.budget_plan : data.budget_plan
        }
        if (data.id > 0) {
            dataPram['id'] = data.id
        }
        
        if (data.company_id) {
            dataPram['company_id'] = data.company_id
        }

        if (data.image) {
            dataPram['pic'] = data.image
        }
        
        dataPram['date_planned_start'] = data.date_planned_start ? data.date_planned_start : 0;
        dataPram['date_planned_end'] = data.date_planned_end ? data.date_planned_end : 0;

        console.log(dataPram);
        const response = await http.post('api/v1/project',
            dataPram,
            {
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'multipart/form-data',
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function archProject(token, projectId) {
    try {
        const dataParam = { id: projectId }

        const response = await http.post(
            'api/v1/project/arhive', 
            dataParam,
            {
                headers: { 
                    'Authorization': 'Bearer ' + token, 
                    'Content-Type': 'multipart/form-data' 
                }
            })

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function archProjectRestore(token, projectId) {
    try {
        const response = await http.get(
            'api/v1/project/arhive', 
            {
                params: { id: projectId },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function trashProject(token, projectId) {
    try {
        const dataParam = { id: projectId }

        const response = await http.post(
            'api/v1/project/trash', 
            dataParam,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function trashProjectRestore(token, projectId) {
    try {
        const response = await http.get(
            'api/v1/project/trash', 
            {
                params: { id: projectId },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            }
        )

        return response.data

    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function delProject(token, projectId) {
    try {
        const response = await http.delete(
            'api/v1/project', 
            {
                params: { id: projectId },
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function listController(token, projectId) {
    try {
        let dataPram = {
            'id': projectId
        }
        const response = await http.get('api/v3/control/project?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function assignController(token, data) {
    try {
        let dataPram = {
            'id': data.projectId,
            'user': data.userId
        }
        const response = await http.post('api/v3/control/project', 
            dataPram,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}

export async function detachController(token, data) {
    try {
        let dataPram = {
            'id': data.projectId,
            'user': data.userId
        }
        const response = await http.get('api/v3/control/proj-delete?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}

export async function listManager(token, projectId) {
    try {
        let dataPram = {
            'id': projectId
        }
        const response = await http.get('api/v3/manager?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json', }
        })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null
    }
}

export async function assignManager(token, data) {
    try {
        let dataPram = {
            'id': data.projectId,
            'user': data.userId
        }
        const response = await http.post('api/v3/manager',
            dataPram,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}

export async function detachManager(token, data) {
    try {
        let dataPram = {
            'id': data.projectId,
            'user': data.userId
        }
        const response = await http.get('api/v3/manager/delete?' + serialize(dataPram), {
            headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
        })
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return null        
    }
}

export async function switchUserRole(token, data) {
    try {
        let dataPram = {
            'project_id': data.projectId,
            'user_id': data.userId,
            'role_id': data.roleId,
        }
        const response = await http.post('api/v1/role/add',
            dataPram,
            {
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'multipart/form-data' }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return false        
    }
}

export async function removeUser(token, data) {
    try {
        let dataPram = {
            'project': data.projectId,
            'user': data.userId
        }
        const response = await http.delete(
            'api/pro/super-admin/project',
            {
                params: dataPram,
                headers: { 'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json' }
            }
        )
        return response.data
    } catch (error) {
        console.error('API error:', error.response?.status, error.message)
        return false        
    }
}
